<template>
	<div class="container-fluid .no-padding" margin=0px >
		<div class="page-title-agenda d-flex justify-content-between align-items-center"  margin=0px padding=0px font-size=18px>
			<h4 v-if="!mobile">Agenda de l'outil {{ title }}</h4>
			<b-button v-if="!mobile" variant="primary" size="sm" @click="changeSystem">Sélectionner un autre matériel</b-button>
		</div>
		<div v-bind:class="[mobile ? ([mobile_version ? 'tight-row-mobile-version row ' : 'tight-row-mobile row ']) : 'tight-row row']">
			<div class="col-md-12">
				<div class="card">
					<div class="no-padding card-block">
						<calendar ref="calendar" :system-id="this.$route.params.id" :rental_max_lenght="this.rental_max_lenght"></calendar>
					</div>
				</div>
			</div>
		</div>
		
		<!-- ######################################################################################### -->        
		<b-modal ref="system_select_popup" hide-footer centered title="Sélectionner un matériel" >
			<v-calendar-select 
				:selected_system_id="this.$route.params.id"
				@Choisir-System-done = "close_select_modal"
			>
			</v-calendar-select>
		</b-modal>
	</div>
</template>

<script>
	import CalendarSelect from '../../components/Calendar/CalendarSelect.vue';
	import Calendar from "../../components/Calendar/Calendar.vue";
	import { mapGetters } from 'vuex';

	export default {
  		name: 'CalendarView',
  		components: {
			Calendar,
			'v-calendar-select': CalendarSelect
  		},
  		data () {
			return{
				mobile: false,
				mobile_version : false,
				window: {
					width: 0,
					height: 0
				},
				rental_max_lenght : 0,
			}
		},
		created() {
			window.addEventListener('resize', this.handleResize);
			this.mobile_version = window.location.hash.includes("m.calendar");
			this.handleResize();
		},
		mounted() {
			this.$store.dispatch('systems/getSystems');
  		},
		destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
  		computed: {
			...mapGetters({
				systems: 'systems/systems'
			}),
			title () {
				if(this.system != undefined) {
					return this.system.name + " - Code : " + this.system.code;
				} else {
					return '';
				}
			},
			system(){
				return this.systems.find(element =>  element.id === parseInt(this.$route.params.id));
			}
 	 	},
		watch: {
			system: {
				deep: true,
				handler: function (newVal) {
					this.rental_max_lenght = newVal.rental_max_lenght;
					if(!(newVal.status & 0x80)){
						this.rental_max_lenght = 0;
					}
				}
			}
		},
		methods : {
			changeSystem() {
                this.$refs.system_select_popup.show();
			},
			close_select_modal(selectedSytem){
                this.$refs.system_select_popup.hide();
				this.$router.push({ path: `/calendar/${selectedSytem.id}`});
			},
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            }
		}
	}
</script>


<style>

	.no-padding{
		padding: 0px
	}

	.tight-row{
		margin-right: -30px;
		margin-left : -30px;
		margin-bottom : -35px;
	}
	.tight-row-mobile{
		margin-right: -30px;
		margin-left : -30px;
		margin-top : -15px;
	}

	.tight-row-mobile-version{
		margin-right: -30px;
		margin-left : -30px;
	}

</style>